(() => {
  const consentmoBottomOffset = '145px';
  const maxAttempts = 40;
  let attempts = 0;

  const positionConsentmo = () => {
    const consentmo = document.querySelector('csm-cookie-consent');
    const reopenButton = consentmo?.shadowRoot?.querySelector('#reopen_widget');
    const positionWrapper = reopenButton?.parentElement;

    if (!positionWrapper) return false;

    positionWrapper.style.bottom = consentmoBottomOffset;
    return true;
  };

  const positionWhenReady = () => {
    if (positionConsentmo() || attempts >= maxAttempts) return;
    attempts += 1;
    window.setTimeout(positionWhenReady, 250);
  };

  document.addEventListener('consentmoSignal_onLoad', positionWhenReady);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionWhenReady, { once: true });
  } else {
    positionWhenReady();
  }
})();
